import { MantineTheme } from "@mantine/core";
import { DataMapMarkerProps, latLng, ValuesRecord } from "@mcurros2/microm";
import { moodSmileIcon } from "../../MapMarkerIcons/MapMarkerIcons";


export function PersonalLocalizacionViewMarkerRenderer(record: ValuesRecord, position: latLng, theme: MantineTheme): DataMapMarkerProps | null {

    let fillColor: string;
    const apellido = record[3] as string;
    const nombre = record[4] as string;
    const fecha = record[5] as string;
    const puesto = record[6] as string;
    const distancia = record[20] as number;

    const icon = moodSmileIcon;

    if (distancia <= 1) {
        fillColor = theme.colors.green[6];
    } else if (distancia <= 4) {
        fillColor = theme.colors.yellow[6];
    } else {
        fillColor = theme.colors.red[6];
    }

    const markerProps: DataMapMarkerProps = {
        position: position,
        title: `${apellido}, ${nombre}${puesto && puesto ? ' - ' : ''}${puesto} - Fecha Localización: ${fecha}`,
        svgIcon: icon,
        assignColorByValue: undefined,
        fillColor: fillColor,
    }

    return markerProps;
}